import { Colors } from '@sweatpals/react-ui-kit';

export const selectTicketModalStyles = () => ({
	modalContainer: {
		position: 'relative',
		backgroundColor: '#1A1A1A',
		height: '100%',

		'*::-webkit-scrollbar': {
			width: '4px',
		},

		'*::-webkit-scrollbar-thumb': {
			borderRadius: '2px',
			backgroundColor: 'rgba(250, 250, 250, 0.7)',
		},
	},
	contentWrapper: {
		position: 'relative',
		display: 'flex',
		maxWidth: '956px',
		flexDirection: 'column',
		margin: '0 auto',
		px: '16px',
	},
	eventInfoBox: {
		display: 'flex',
		padding: '24px',
		gap: '12px',
		borderRadius: '8px 8px 0px 0px',
		border: '2px solid rgba(255,255,255, 0.1)',
		background: Colors.black_a40,
		color: 'white',
		alignItems: 'center',
		borderBottomStyle: 'dashed',
	},
	eventInfoContent: {
		display: 'flex',
		flexDirection: 'column',
		gap: '4px',
	},
	eventName: {
		color: 'white',
		fontFamily: 'Montserrat',
		fontSize: '16px',
		fontWeight: '700',
		lineHeight: '24px',
	},
	eventDate: {
		color: 'white',
		fontFamily: 'Montserrat',
		fontSize: '14px',
		fontWeight: '500',
	},
	ticketsContainer: {
		display: 'flex',
		padding: {
			xs: '16px',
			sm: '24px',
		},
		flexDirection: 'column',
		gap: '18px',
		borderRadius: '0px 0px 8px 8px',
		background: Colors.black_a30,
		alignItems: 'center',
	},
	tiersContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: '8px',
		width: '100%',
	},
	tierLabel: {
		color: '#FFF',
		fontFamily: 'General Sans',
		fontSize: '14px',
		fontWeight: '600',
		lineHeight: '18px',
	},
	bottomButtonContainer: {
		position: 'fixed',
		bottom: 0,
		width: '100%',
		padding: '57px 23px 18px',
		background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 30.43%, #000 84.78%)',
	},
	logo: {
		cursor: 'default',
		height: '21px',
	},
	closeButton: {
		color: '#FFFFFF',
		border: '1px solid #FFFFFF66',
		width: '48px',
		height: '48px',
	},
	modalNav: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		px: { xs: '16px', lg: '64px' },
		py: { xs: '16px', sm: '32px' },
	},
	navContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
});
